export const SEARCHBAR_HISTORY_LOCAL_STORAGE_KEY = 'search-history'
